import { withTheme } from 'styled-components'

export const HeaderIconReceiveSubmission = withTheme(({ theme, ...props }) =>
	theme.colorScheme === 'light' ? (
		<svg {...props} width='375' height='250' viewBox='0 0 375 250' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M349.25 170.28C349.25 80.95 276.83 8.53003 187.5 8.53003C98.17 8.53003 25.75 80.95 25.75 170.28H349.25Z'
				fill='url(#paint0_radial_2807_33924)'
			/>
			<path
				d='M240.83 239.67C256.73 239.67 269.62 235.376 269.62 230.08C269.62 224.784 256.73 220.49 240.83 220.49C224.93 220.49 212.04 224.784 212.04 230.08C212.04 235.376 224.93 239.67 240.83 239.67Z'
				fill='#EFEFEF'
			/>
			<path d='M153.51 37.08L181.57 29.26L155.9 33.64L153.51 37.08Z' fill='#37AAA0' />
			<path
				d='M145.08 28.4L181.57 29.26L165.39 38.24L155.9 33.64L181.29 29.38L152.21 31.85L145.08 28.4Z'
				fill='#ACDFDE'
			/>
			<path d='M152.21 31.85L153.51 37.08L155.9 33.64L181.57 29.26L152.21 31.85Z' fill='#85D0CC' />
			<path
				d='M260.39 199.51C260.06 201.54 256.08 203.69 254.76 206.31C253.46 208.92 251.11 211.01 250 211.08C248.88 211.14 244.24 211.01 243.14 210.49C243.14 210.49 243.66 207.09 245.36 206.44C247.05 205.78 249.33 203.07 249.38 201.01C249.42 199.95 249.31 198.68 249.22 197.44C248.93 193.4 248.8 189.53 254 193.22C254.27 193.42 255.03 193.91 255.95 194.55C257.94 195.97 260.62 198.12 260.39 199.51Z'
				fill='#D7D7D7'
			/>
			<path
				d='M228.01 75.03C232.22 79.41 232.52 93.35 228.01 95.67C225.5 96.96 225.4 93.32 223.14 89.13C220.88 84.94 214.45 69.36 212.79 64.53C212.57 63.98 212.35 63.33 212.12 62.6C211.97 62.16 211.87 61.83 211.82 61.59C211.42 60.19 210.76 56.13 210.13 51.6C209.39 46.23 210.67 47.3 209.59 41.13C208.86 36.98 210 35.3 211.24 35.31C212.57 35.31 213.4 36.81 213.59 39.9C213.63 40.59 213.95 41.55 214.19 43.48C214.71 47.66 219.15 57.92 219.93 60.24C221.03 63.53 228.02 75.03 228.02 75.03H228.01Z'
				fill='#E49575'
			/>
			<path
				d='M209.34 43.15C210.33 42.85 212.94 42.18 215.23 43.01C215.39 43.07 215.5 43.21 215.52 43.37C215.78 45.05 217.9 52.8 221.14 61.81C224.71 71.73 231.28 77.68 233.23 79.26C236.07 81.56 222.54 97.39 221.81 94.83C218.08 81.85 213.66 71.08 211.71 63.37C210.41 58.24 209.28 45.79 209.09 43.55C209.07 43.37 209.18 43.21 209.35 43.15H209.34Z'
				fill='#00847A'
			/>
			<path
				d='M238.12 62.56C241.616 62.56 244.45 59.726 244.45 56.23C244.45 52.7341 241.616 49.9 238.12 49.9C234.624 49.9 231.79 52.7341 231.79 56.23C231.79 59.726 234.624 62.56 238.12 62.56Z'
				fill='#9D5E4A'
			/>
			<path
				d='M242.77 73.89C242.77 73.89 241.28 77.62 242.02 79.78C242.77 81.94 233.71 87.5 230.66 84.26C228.38 81.85 232.4 77.54 231.66 70.66C230.91 63.77 237.96 67.18 239.29 67.92C240.62 68.66 245.1 70.82 242.77 73.89Z'
				fill='#E49575'
			/>
			<path
				d='M231.51 72.27C231.51 72.27 231.51 75.29 233.57 75.56C236.14 75.9 241.17 73.49 241.26 73.16C241.35 72.83 231.51 72.27 231.51 72.27Z'
				fill='#D88466'
			/>
			<path
				d='M242.85 74.01C241.96 74.36 240.98 74.06 240.11 74.06C235.27 74.06 231.99 73.65 231.99 73.65C231.99 73.65 226.89 73.19 226.56 70.62C226.36 69.01 227.14 66.15 228.21 64.22C228.62 63.49 229.07 62.89 229.52 62.54C230.11 62.08 230.69 61.61 231.13 61.01C231.3 60.78 231.5 60.52 231.73 60.26C231.88 60.07 232.06 59.88 232.25 59.68C233.52 58.31 235.4 56.84 237.71 56.57C242.11 56.04 246.28 58.53 248.49 62.9C250.73 67.34 245.36 73.02 242.85 74.02V74.01Z'
				fill='#E49575'
			/>
			<path
				d='M242.66 74.19C241.65 74.54 241.6 71.98 243.48 70.76C245.36 69.54 245.8 68.01 244.46 68.01C241.55 68.01 241.32 65.95 242.6 64.59C244.95 62.1 240.58 55.2 236.59 56.8C236.59 56.8 239.1 51.13 246.45 55.15C253.34 58.92 249.73 63.9 249.73 63.9C249.67 62.57 256.26 69.49 242.66 74.19Z'
				fill='#9D5E4A'
			/>
			<path
				d='M243.21 67.79C243.43 67.74 246.8 67.49 245.89 70.17C245.23 72.09 242.83 73.71 241.39 71.89C239.95 70.06 241.67 68.13 243.22 67.8L243.21 67.79Z'
				fill='#E49575'
			/>
			<path
				d='M223.64 106.43C223.64 106.43 226.93 119.1 226.35 124.08C225.77 129.06 244.35 125.91 244.19 123.42C244.02 120.93 243.98 116.43 246.27 113.17C248.56 109.92 239.96 102.93 236.14 102.84C232.32 102.75 221.93 100.19 223.64 106.43Z'
				fill='#F4B9A2'
			/>
			<path
				d='M226.35 124.08C226.35 124.08 227.26 124.83 229.59 124.72C231.92 124.61 243.94 119.15 244.15 122.62C244.33 125.67 249.43 131.82 248.06 138.99C245.07 154.61 230.81 145.18 228.92 143.64C227.03 142.1 224.8 137.01 224.91 133.91C225.02 130.81 225.52 128.82 226.35 124.09V124.08Z'
				fill='#F4B9A2'
			/>
			<path
				d='M243.11 231.34C241.37 231.94 238.87 235.05 235.41 236.62C231.95 238.17 225.39 235.49 225.39 235.49C225.38 235.17 225.39 234.87 225.44 234.59C225.95 230.76 230.6 229.3 231.96 228.57C233.08 227.98 235.5 224.32 236.86 221.95C237.28 221.22 237.6 220.61 237.74 220.27C238.29 218.99 241.92 218.01 243.65 218.87C244.36 219.22 244.65 220.26 244.79 221.49C244.99 223.28 244.84 225.49 245.1 226.67C245.15 226.9 245.18 227.14 245.19 227.38C245.34 229.13 244.64 230.8 243.11 231.34Z'
				fill='#D7D7D7'
			/>
			<path
				d='M255.94 194.56C256.48 197.64 252.52 199.01 252.52 199.01C251.05 196.15 249.36 197.33 249.36 197.33L249.21 197.45C248.92 193.41 248.79 189.54 253.99 193.23C254.26 193.43 255.02 193.92 255.94 194.56Z'
				fill='#E49575'
			/>
			<path
				d='M259.07 91.87C250.2 81.66 242.15 78.43 242.04 81.2C241.95 83.56 241.89 87.3 242.7 91.26C243.51 95.22 251.21 99.25 254.29 102.24C255.59 103.5 257.86 105.62 260.26 107.38C261.7 108.45 263.5 109.92 264.15 111.59C266.28 117.03 267.76 121.29 268.01 129.99C268.16 135.2 271.81 133.3 271.92 131.98C272.68 123.52 272.04 112.9 271.52 110.25C269.77 101.25 260.83 93.91 259.06 91.87H259.07Z'
				fill='#E49575'
			/>
			<path
				d='M270.59 130.49C272.2 130.59 272.54 131.77 273.43 134.22C273.95 135.64 274.67 138.93 275.38 140.08C276.09 141.23 275.74 143.19 275.38 143.46C275.38 143.46 275.07 146.08 274.4 145.95C273.73 145.82 273.73 145.15 273.73 145.15C273.73 145.15 272.26 146.31 272.31 144.22C272.35 142.13 271.87 140.8 271.87 140.8C271.87 140.8 272.23 143.24 271.43 143.38C270.63 143.52 270.66 142.82 270.59 142.18C270.38 140.39 270.15 139.16 269.61 138.23C269.07 137.3 269.25 135.34 267.43 135.34C265.61 135.34 264.01 136.89 263.39 136.76C262.77 136.63 262.96 135.75 263.7 135.03C264.66 134.1 268.07 131.22 268.25 130.86C268.43 130.5 268.45 130.36 270.59 130.5V130.49Z'
				fill='#E49575'
			/>
			<path
				d='M244.79 221.49C244.37 224.65 240.82 224.26 240.82 224.26C238.79 220.18 236.85 221.95 236.85 221.95C237.27 221.22 237.59 220.61 237.73 220.27C238.28 218.99 241.91 218.01 243.64 218.87C244.35 219.22 244.64 220.26 244.78 221.49H244.79Z'
				fill='#E49575'
			/>
			<path
				d='M222.12 134.66C221.91 143.02 222.61 167.57 228.98 177.74C229.32 178.29 229.69 178.81 230.06 179.3C239.56 191.58 248.28 199 248.28 199L254.62 194.22C255.83 193.3 255.31 192.82 255 192.12C255 192.12 247.57 179.11 243.13 171.98C239.64 166.37 234.45 153.15 234.69 135.7L222.12 134.65V134.66Z'
				fill='#585858'
			/>
			<path
				d='M227.98 135.51C227.98 135.51 230.73 160.37 231.52 178.96C231.9 187.91 236.6 219.47 236.6 219.47C239.04 220.65 242.26 220.63 244.86 220.33C247.32 220.05 247.86 219.12 247.43 215.08C246.77 208.85 246.4 203.55 245.83 198.85C244.9 191.15 245.13 185.11 245.48 178.6C246.31 163.09 250.4 142.24 249.63 134.66L227.98 135.51Z'
				fill='#686868'
			/>
			<path
				d='M253.39 92.68C253.34 94.43 252.92 97.51 252.26 100.91C252.18 101.31 252.1 101.72 252.01 102.13C251.72 103.55 251.22 104.99 250.71 106.38C249.69 109.15 248.56 111.76 248.75 113.88C249.36 120.72 249.67 135.09 249.67 135.09C248.78 136.22 247.06 137.46 242.27 138.56C240.66 138.92 238.81 139.04 236.91 138.98C233.28 138.86 229.42 138.05 226.33 137.44C222.64 136.71 220.7 136.27 220.05 136.12C219.9 136.09 219.8 135.95 219.8 135.8C219.8 124.45 220.72 118.3 220.78 112.72C220.83 107.71 220.02 102.99 220.25 98.13C221.17 78.69 230.85 78.2 230.85 78.2C230.85 78.2 229.15 84.46 232.26 85.01C236.38 85.76 241.85 78.86 241.85 78.86C256.28 81.05 253.5 88.54 253.39 92.67V92.68Z'
				fill='#00847A'
			/>
			<path
				d='M253.61 84.43C257.6 87.78 259.5 90.01 262.4 93.62C265.5 97.48 268.24 100.44 270.97 105.72C271.84 107.4 273.06 124.4 273.06 128.68C273.06 130.12 273.06 130.04 271.82 130.18C270.58 130.32 268.68 130.48 267.42 129.95C267.42 129.95 264.54 114.09 262.54 110.28C260.54 106.47 249.67 100.27 248.2 96.2C246.5 91.52 239.64 72.69 253.61 84.44V84.43Z'
				fill='#00847A'
			/>
			<path
				d='M252.26 100.9C252.18 101.3 252.1 101.71 252.01 102.12C251.72 103.54 251.22 104.98 250.71 106.37C250.71 106.36 250.72 106.33 250.72 106.32C251.65 102.29 249 97.68 248.72 97.2C249.75 98.66 252.26 100.89 252.26 100.89V100.9Z'
				fill='#00716B'
			/>
			<path
				d='M235.04 92.21C235.04 92.21 237.12 92.58 239.64 93.55C239.64 93.55 238.89 95.54 238.15 97.76L235.2 99.68L233.86 96.31C233.86 96.31 234.23 94.96 235.05 92.21H235.04Z'
				fill='#00716B'
			/>
			<path d='M235.19 99.68C235.19 99.68 235.79 97.38 236.42 95.12L238.14 97.75L235.19 99.67V99.68Z' fill='#E5B300' />
			<path
				d='M214.21 33.54C214.21 33.54 214.14 33.54 214.1 33.54C213.66 33.48 213.04 32.82 213.1 32.38C213.74 27.79 215.66 24.81 215.73 24.66C215.92 24.25 216.47 23.64 216.86 23.85C217.35 24.11 217.19 24.86 217 25.27C216.98 25.3 215.65 28.27 215.22 32.77C215.1 34.04 214.6 33.55 214.2 33.55L214.21 33.54Z'
				fill='#E49575'
			/>
			<path
				d='M212.05 32.37C211.66 32.37 211.12 31.92 211.08 31.51C210.71 28 210.54 23.88 210.52 23.65C210.49 23.2 210.66 22.68 211.11 22.65C211.58 22.65 211.81 23.04 211.84 23.48C211.84 23.54 212.59 28.04 213.09 31.33C213.16 31.77 212.61 32.29 212.17 32.36C212.13 32.36 212.09 32.36 212.05 32.36V32.37Z'
				fill='#E49575'
			/>
			<path
				d='M210.28 32.98C209.94 32.98 209.63 32.77 209.51 32.44C208.53 29.62 207.06 26.77 207.05 26.74C206.83 26.35 206.73 25.75 207.11 25.5C207.4 25.31 207.86 25.57 208.27 26.1C208.36 26.22 210.12 28.75 211.16 31.71C211.31 32.13 210.97 32.79 210.55 32.94C210.46 32.97 210.37 32.99 210.28 32.99V32.98Z'
				fill='#E49575'
			/>
			<path
				d='M208.89 34.48C208.49 34.48 208.15 34.19 208.09 33.78C207.8 31.7 207.5 31.65 207.03 30.9C206.79 30.52 206.19 29.82 206.48 29.49C206.76 29.15 207.36 29.51 207.7 29.8C207.77 29.86 209.24 30.7 209.69 33.13C209.77 33.57 209.43 34.42 208.99 34.48C208.95 34.48 208.91 34.48 208.88 34.48H208.89Z'
				fill='#E49575'
			/>
			<path
				d='M214.47 35.55C214.28 35.55 214.08 35.48 213.93 35.34C213.6 35.04 213.57 34.53 213.87 34.2C216.2 31.62 218.2 31.52 218.43 31.52H218.44C218.88 31.52 219.41 31.74 219.42 32.18C219.43 32.62 219.11 32.73 218.46 33.14C217.34 33.84 216.82 34.26 215.62 36.14C215.49 36.34 214.7 35.55 214.48 35.55H214.47Z'
				fill='#E49575'
			/>
			<path
				d='M215.61 36.13C215.2 36.74 214.42 37.53 214.16 37.76C213.9 37.99 213.66 39.4 211.9 39.63C210.77 39.78 209.15 39.72 209.46 37.41C209.77 35.1 211.61 33.93 213.87 34.2C216.13 34.47 215.61 36.14 215.61 36.14V36.13Z'
				fill='#E49575'
			/>
			<path
				d='M208.09 33.78C208.09 33.78 208.2 35.24 208.43 36.91C208.66 38.58 209.74 38.68 209.91 38.63L214.19 35.98L215.14 33.74L213.45 30.48C213.38 30.82 213 30.68 212.97 30.48C212.94 30.28 210.77 30.7 210.77 30.7L209.42 31.5L208.89 32.28L208.08 33.77L208.09 33.78Z'
				fill='#E49575'
			/>
			<path d='M293.32 34H274.64V61.61H293.32V34Z' fill='#EFEFEF' />
			<path d='M293.31 34V61.61H274.64V34H293.31ZM295.72 31.64H272.28V64.02H295.72V31.65V31.64Z' fill='#F4F4F4' />
			<path d='M317.62 52.98H301.83V76.31H317.62V52.98Z' fill='#EFEFEF' />
			<path d='M317.62 52.98V76.3H301.83V52.98H317.62ZM320.03 50.62H299.43V78.78H320.03V50.62Z' fill='#F4F4F4' />
			<path fillRule='evenodd' clipRule='evenodd' d='M306.98 73.28V62.32L312.47 67.79L306.98 73.28Z' fill='#F4F4F4' />
			<path fillRule='evenodd' clipRule='evenodd' d='M306.98 70.09V59.13L312.47 64.6L306.98 70.09Z' fill='#EFEFEF' />
			<path fillRule='evenodd' clipRule='evenodd' d='M306.98 66.74V55.78L312.47 61.25L306.98 66.74Z' fill='#F4F4F4' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M278.46 43.57H289.51V52.79L284.01 47.3V58.28L278.45 52.78V43.56L278.46 43.57Z'
				fill='#F4F4F4'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M278.46 40.47H289.51V49.69L284.01 44.2V55.18L278.45 49.68V40.46L278.46 40.47Z'
				fill='#EFEFEF'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M278.47 37.33H289.52V46.55L284.02 41.06V52.04L278.46 46.54V37.32L278.47 37.33Z'
				fill='#F4F4F4'
			/>
			<path
				d='M101.11 201.22C122.506 201.22 139.85 197.491 139.85 192.89C139.85 188.289 122.506 184.56 101.11 184.56C79.7146 184.56 62.3701 188.289 62.3701 192.89C62.3701 197.491 79.7146 201.22 101.11 201.22Z'
				fill='#F4F4F4'
			/>
			<path d='M74.8201 107.92H125.91C127.18 107.92 128.21 108.95 128.21 110.22V126.3H74.8201V107.92Z' fill='#EFEFEF' />
			<path
				d='M75.4901 95.66H100.83C101.2 95.66 101.51 95.96 101.51 96.34V107.92H74.8201V96.34C74.8201 95.97 75.1201 95.66 75.5001 95.66H75.4901Z'
				fill='#E7E7E7'
			/>
			<path d='M101.51 103.86L127.25 102.16C127.81 102.04 128.2 101.54 128.2 100.97V97.7401H101.51' fill='#E7E7E7' />
			<path
				d='M103.13 112.97H128.21V126.3H101.52V114.59C101.52 113.7 102.24 112.97 103.14 112.97H103.13Z'
				fill='url(#paint1_linear_2807_33924)'
			/>
			<path
				d='M128.21 126.3H74.81C72.54 126.3 70.72 128.18 70.79 130.45L71.35 148.36L71.69 159.38L72.03 170.41L72.65 190.4C72.69 191.55 73.63 192.46 74.77 192.46H128.24C129.39 192.46 130.33 191.55 130.36 190.4L130.98 170.41L131.32 159.38L131.66 148.36L132.22 130.45C132.29 128.18 130.47 126.3 128.2 126.3H128.21Z'
				fill='url(#paint2_linear_2807_33924)'
			/>
			<path
				d='M79.7501 123.15H96.1701C96.6701 123.15 97.0501 122.69 96.9601 122.2L95.3301 113.61C95.2601 113.23 94.9301 112.96 94.5401 112.96H81.3801C81.0001 112.96 80.6601 113.23 80.5901 113.61L78.9601 122.2C78.8701 122.69 79.2401 123.15 79.7501 123.15Z'
				fill='#F8F8F8'
			/>
			<path
				d='M94.4001 148.35H108.62V150.83C108.62 151.65 107.96 152.31 107.14 152.31H95.8901C95.0701 152.31 94.4101 151.65 94.4101 150.83V148.35H94.4001Z'
				fill='#E7E7E7'
			/>
			<path
				d='M94.4001 170.28H108.62V172.76C108.62 173.58 107.96 174.24 107.14 174.24H95.8901C95.0701 174.24 94.4101 173.58 94.4101 172.76V170.28H94.4001Z'
				fill='#E7E7E7'
			/>
			<path
				d='M94.4001 126.3H108.62V128.78C108.62 129.6 107.96 130.26 107.14 130.26H95.8901C95.0701 130.26 94.4101 129.6 94.4101 128.78V126.3H94.4001Z'
				fill='#E7E7E7'
			/>
			<path
				d='M94.4001 181.3H108.62V183.78C108.62 184.6 107.96 185.26 107.14 185.26H95.8901C95.0701 185.26 94.4101 184.6 94.4101 183.78V181.3H94.4001Z'
				fill='#E7E7E7'
			/>
			<path
				d='M75.5901 195.77C76.2201 195.02 77.1501 194.52 78.2001 194.52C79.2501 194.52 80.1901 195.01 80.8101 195.77C81.2701 195.54 81.5801 195.07 81.5801 194.52V192.44H74.8101V194.52C74.8101 195.07 75.1301 195.53 75.5801 195.77H75.5901Z'
				fill='#E7E7E7'
			/>
			<path
				d='M122.2 195.77C122.83 195.02 123.76 194.52 124.81 194.52C125.86 194.52 126.8 195.01 127.42 195.77C127.88 195.54 128.19 195.07 128.19 194.52V192.44H121.42V194.52C121.42 195.07 121.74 195.53 122.19 195.77H122.2Z'
				fill='#E7E7E7'
			/>
			<defs>
				<radialGradient
					id='paint0_radial_2807_33924'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(188.28 170.38) rotate(180) scale(160.36)'
				>
					<stop offset='0.06' stopColor='#EFEFEF' />
					<stop offset='0.85' stopColor='#F6F6F6' />
					<stop offset='0.98' stopColor='#F8F8F8' />
				</radialGradient>
				<linearGradient
					id='paint1_linear_2807_33924'
					x1='114.77'
					y1='114.79'
					x2='114.94'
					y2='124.64'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.07' stopColor='#DBDBDB' />
					<stop offset='0.53' stopColor='#E2E2E2' />
					<stop offset='0.98' stopColor='#EFEFEF' />
				</linearGradient>
				<linearGradient
					id='paint2_linear_2807_33924'
					x1='101.51'
					y1='192.44'
					x2='101.51'
					y2='126.3'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.06' stopColor='#EFEFEF' />
					<stop offset='0.85' stopColor='#F6F6F6' />
					<stop offset='0.98' stopColor='#F8F8F8' />
				</linearGradient>
			</defs>
		</svg>
	) : (
		<svg {...props} width='375' height='250' viewBox='0 0 375 250' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M240.83 239.67C256.73 239.67 269.62 235.376 269.62 230.08C269.62 224.784 256.73 220.49 240.83 220.49C224.93 220.49 212.04 224.784 212.04 230.08C212.04 235.376 224.93 239.67 240.83 239.67Z'
				fill='#181818'
			/>
			<path d='M153.51 37.08L181.57 29.26L155.9 33.64L153.51 37.08Z' fill='#37AAA0' />
			<path
				d='M145.08 28.4L181.57 29.26L165.39 38.24L155.9 33.64L181.29 29.38L152.21 31.85L145.08 28.4Z'
				fill='#ACDFDE'
			/>
			<path d='M152.21 31.85L153.51 37.08L155.9 33.64L181.57 29.26L152.21 31.85Z' fill='#85D0CC' />
			<path
				d='M260.39 199.51C260.06 201.54 256.08 203.69 254.76 206.31C253.46 208.92 251.11 211.01 250 211.08C248.88 211.14 244.24 211.01 243.14 210.49C243.14 210.49 243.66 207.09 245.36 206.44C247.05 205.78 249.33 203.07 249.38 201.01C249.42 199.95 249.31 198.68 249.22 197.44C248.93 193.4 248.8 189.53 254 193.22C254.27 193.42 255.03 193.91 255.95 194.55C257.94 195.97 260.62 198.12 260.39 199.51Z'
				fill='#D7D7D7'
			/>
			<path
				d='M228.01 75.03C232.22 79.41 232.52 93.35 228.01 95.67C225.5 96.96 225.4 93.32 223.14 89.13C220.88 84.94 214.45 69.36 212.79 64.53C212.57 63.98 212.35 63.33 212.12 62.6C211.97 62.16 211.87 61.83 211.82 61.59C211.42 60.19 210.76 56.13 210.13 51.6C209.39 46.23 210.67 47.3 209.59 41.13C208.86 36.98 210 35.3 211.24 35.31C212.57 35.31 213.4 36.81 213.59 39.9C213.63 40.59 213.95 41.55 214.19 43.48C214.71 47.66 219.15 57.92 219.93 60.24C221.03 63.53 228.02 75.03 228.02 75.03H228.01Z'
				fill='#E49575'
			/>
			<path
				d='M209.34 43.15C210.33 42.85 212.94 42.18 215.23 43.01C215.39 43.07 215.5 43.21 215.52 43.37C215.78 45.05 217.9 52.8 221.14 61.81C224.71 71.73 231.28 77.68 233.23 79.26C236.07 81.56 222.54 97.39 221.81 94.83C218.08 81.85 213.66 71.08 211.71 63.37C210.41 58.24 209.28 45.79 209.09 43.55C209.07 43.37 209.18 43.21 209.35 43.15H209.34Z'
				fill='#00847A'
			/>
			<path
				d='M238.12 62.56C241.616 62.56 244.45 59.726 244.45 56.23C244.45 52.7341 241.616 49.9 238.12 49.9C234.624 49.9 231.79 52.7341 231.79 56.23C231.79 59.726 234.624 62.56 238.12 62.56Z'
				fill='#9D5E4A'
			/>
			<path
				d='M242.77 73.89C242.77 73.89 241.28 77.62 242.02 79.78C242.77 81.94 233.71 87.5 230.66 84.26C228.38 81.85 232.4 77.54 231.66 70.66C230.91 63.77 237.96 67.18 239.29 67.92C240.62 68.66 245.1 70.82 242.77 73.89Z'
				fill='#E49575'
			/>
			<path
				d='M231.51 72.27C231.51 72.27 231.51 75.29 233.57 75.56C236.14 75.9 241.17 73.49 241.26 73.16C241.35 72.83 231.51 72.27 231.51 72.27Z'
				fill='#D88466'
			/>
			<path
				d='M242.85 74.01C241.96 74.36 240.98 74.06 240.11 74.06C235.27 74.06 231.99 73.65 231.99 73.65C231.99 73.65 226.89 73.19 226.56 70.62C226.36 69.01 227.14 66.15 228.21 64.22C228.62 63.49 229.07 62.89 229.52 62.54C230.11 62.08 230.69 61.61 231.13 61.01C231.3 60.78 231.5 60.52 231.73 60.26C231.88 60.07 232.06 59.88 232.25 59.68C233.52 58.31 235.4 56.84 237.71 56.57C242.11 56.04 246.28 58.53 248.49 62.9C250.73 67.34 245.36 73.02 242.85 74.02V74.01Z'
				fill='#E49575'
			/>
			<path
				d='M242.66 74.19C241.65 74.54 241.6 71.98 243.48 70.76C245.36 69.54 245.8 68.01 244.46 68.01C241.55 68.01 241.32 65.95 242.6 64.59C244.95 62.1 240.58 55.2 236.59 56.8C236.59 56.8 239.1 51.13 246.45 55.15C253.34 58.92 249.73 63.9 249.73 63.9C249.67 62.57 256.26 69.49 242.66 74.19Z'
				fill='#9D5E4A'
			/>
			<path
				d='M243.21 67.79C243.43 67.74 246.8 67.49 245.89 70.17C245.23 72.09 242.83 73.71 241.39 71.89C239.95 70.06 241.67 68.13 243.22 67.8L243.21 67.79Z'
				fill='#E49575'
			/>
			<path
				d='M223.64 106.43C223.64 106.43 226.93 119.1 226.35 124.08C225.77 129.06 244.35 125.91 244.19 123.42C244.02 120.93 243.98 116.43 246.27 113.17C248.56 109.92 239.96 102.93 236.14 102.84C232.32 102.75 221.93 100.19 223.64 106.43Z'
				fill='#F4B9A2'
			/>
			<path
				d='M226.35 124.08C226.35 124.08 227.26 124.83 229.59 124.72C231.92 124.61 243.94 119.15 244.15 122.62C244.33 125.67 249.43 131.82 248.06 138.99C245.07 154.61 230.81 145.18 228.92 143.64C227.03 142.1 224.8 137.01 224.91 133.91C225.02 130.81 225.52 128.82 226.35 124.09V124.08Z'
				fill='#F4B9A2'
			/>
			<path
				d='M243.11 231.34C241.37 231.94 238.87 235.05 235.41 236.62C231.95 238.17 225.39 235.49 225.39 235.49C225.38 235.17 225.39 234.87 225.44 234.59C225.95 230.76 230.6 229.3 231.96 228.57C233.08 227.98 235.5 224.32 236.86 221.95C237.28 221.22 237.6 220.61 237.74 220.27C238.29 218.99 241.92 218.01 243.65 218.87C244.36 219.22 244.65 220.26 244.79 221.49C244.99 223.28 244.84 225.49 245.1 226.67C245.15 226.9 245.18 227.14 245.19 227.38C245.34 229.13 244.64 230.8 243.11 231.34Z'
				fill='#D7D7D7'
			/>
			<path
				d='M255.94 194.56C256.48 197.64 252.52 199.01 252.52 199.01C251.05 196.15 249.36 197.33 249.36 197.33L249.21 197.45C248.92 193.41 248.79 189.54 253.99 193.23C254.26 193.43 255.02 193.92 255.94 194.56Z'
				fill='#E49575'
			/>
			<path
				d='M259.071 91.87C250.201 81.66 242.15 78.43 242.04 81.2C241.95 83.56 241.89 87.3 242.7 91.26C243.51 95.22 251.21 99.25 254.29 102.24C255.59 103.5 257.861 105.62 260.261 107.38C261.701 108.45 263.5 109.92 264.15 111.59C266.28 117.03 267.761 121.29 268.011 129.99C268.161 135.2 271.811 133.3 271.921 131.98C272.681 123.52 272.04 112.9 271.52 110.25C269.77 101.25 260.83 93.91 259.06 91.87H259.071Z'
				fill='#E49575'
			/>
			<path
				d='M270.59 130.49C272.2 130.59 272.54 131.77 273.43 134.22C273.95 135.64 274.67 138.93 275.38 140.08C276.09 141.23 275.74 143.19 275.38 143.46C275.38 143.46 275.07 146.08 274.4 145.95C273.73 145.82 273.73 145.15 273.73 145.15C273.73 145.15 272.26 146.31 272.31 144.22C272.35 142.13 271.87 140.8 271.87 140.8C271.87 140.8 272.23 143.24 271.43 143.38C270.63 143.52 270.66 142.82 270.59 142.18C270.38 140.39 270.15 139.16 269.61 138.23C269.07 137.3 269.25 135.34 267.43 135.34C265.61 135.34 264.01 136.89 263.39 136.76C262.77 136.63 262.96 135.75 263.7 135.03C264.66 134.1 268.07 131.22 268.25 130.86C268.43 130.5 268.45 130.36 270.59 130.5V130.49Z'
				fill='#E49575'
			/>
			<path
				d='M244.79 221.49C244.37 224.65 240.82 224.26 240.82 224.26C238.79 220.18 236.85 221.95 236.85 221.95C237.27 221.22 237.59 220.61 237.73 220.27C238.28 218.99 241.91 218.01 243.64 218.87C244.35 219.22 244.64 220.26 244.78 221.49H244.79Z'
				fill='#E49575'
			/>
			<path
				d='M222.12 134.66C221.91 143.02 222.61 167.57 228.98 177.74C229.32 178.29 229.69 178.81 230.06 179.3C239.56 191.58 248.28 199 248.28 199L254.62 194.22C255.83 193.3 255.31 192.82 255 192.12C255 192.12 247.57 179.11 243.13 171.98C239.64 166.37 234.45 153.15 234.69 135.7L222.12 134.65V134.66Z'
				fill='#585858'
			/>
			<path
				d='M227.98 135.51C227.98 135.51 230.73 160.37 231.52 178.96C231.9 187.91 236.6 219.47 236.6 219.47C239.04 220.65 242.26 220.63 244.86 220.33C247.32 220.05 247.86 219.12 247.43 215.08C246.77 208.85 246.4 203.55 245.83 198.85C244.9 191.15 245.13 185.11 245.48 178.6C246.31 163.09 250.4 142.24 249.63 134.66L227.98 135.51Z'
				fill='#686868'
			/>
			<path
				d='M253.39 92.68C253.34 94.43 252.92 97.51 252.26 100.91C252.18 101.31 252.1 101.72 252.01 102.13C251.72 103.55 251.22 104.99 250.71 106.38C249.69 109.15 248.56 111.76 248.75 113.88C249.36 120.72 249.67 135.09 249.67 135.09C248.78 136.22 247.06 137.46 242.27 138.56C240.66 138.92 238.81 139.04 236.91 138.98C233.28 138.86 229.42 138.05 226.33 137.44C222.64 136.71 220.7 136.27 220.05 136.12C219.9 136.09 219.8 135.95 219.8 135.8C219.8 124.45 220.72 118.3 220.78 112.72C220.83 107.71 220.02 102.99 220.25 98.13C221.17 78.69 230.85 78.2 230.85 78.2C230.85 78.2 229.15 84.46 232.26 85.01C236.38 85.76 241.85 78.86 241.85 78.86C256.28 81.05 253.5 88.54 253.39 92.67V92.68Z'
				fill='#00847A'
			/>
			<path
				d='M253.61 84.43C257.6 87.78 259.5 90.01 262.4 93.62C265.5 97.48 268.24 100.44 270.97 105.72C271.84 107.4 273.06 124.4 273.06 128.68C273.06 130.12 273.06 130.04 271.82 130.18C270.58 130.32 268.68 130.48 267.42 129.95C267.42 129.95 264.54 114.09 262.54 110.28C260.54 106.47 249.67 100.27 248.2 96.2C246.5 91.52 239.64 72.69 253.61 84.44V84.43Z'
				fill='#00847A'
			/>
			<path
				d='M252.26 100.9C252.18 101.3 252.1 101.71 252.01 102.12C251.72 103.54 251.22 104.98 250.71 106.37C250.71 106.36 250.72 106.33 250.72 106.32C251.65 102.29 249 97.68 248.72 97.2C249.75 98.66 252.26 100.89 252.26 100.89V100.9Z'
				fill='#00716B'
			/>
			<path
				d='M235.04 92.21C235.04 92.21 237.12 92.58 239.64 93.55C239.64 93.55 238.89 95.54 238.15 97.76L235.2 99.68L233.86 96.31C233.86 96.31 234.23 94.96 235.05 92.21H235.04Z'
				fill='#00716B'
			/>
			<path d='M235.19 99.68C235.19 99.68 235.79 97.38 236.42 95.12L238.14 97.75L235.19 99.67V99.68Z' fill='#E5B300' />
			<path
				d='M214.21 33.54C214.21 33.54 214.14 33.54 214.1 33.54C213.66 33.48 213.04 32.82 213.1 32.38C213.74 27.79 215.66 24.81 215.73 24.66C215.92 24.25 216.47 23.64 216.86 23.85C217.35 24.11 217.19 24.86 217 25.27C216.98 25.3 215.65 28.27 215.22 32.77C215.1 34.04 214.6 33.55 214.2 33.55L214.21 33.54Z'
				fill='#E49575'
			/>
			<path
				d='M212.05 32.37C211.66 32.37 211.12 31.92 211.08 31.51C210.71 28 210.54 23.88 210.52 23.65C210.49 23.2 210.66 22.68 211.11 22.65C211.58 22.65 211.81 23.04 211.84 23.48C211.84 23.54 212.59 28.04 213.09 31.33C213.16 31.77 212.61 32.29 212.17 32.36C212.13 32.36 212.09 32.36 212.05 32.36V32.37Z'
				fill='#E49575'
			/>
			<path
				d='M210.28 32.98C209.94 32.98 209.63 32.77 209.51 32.44C208.53 29.62 207.06 26.77 207.05 26.74C206.83 26.35 206.73 25.75 207.11 25.5C207.4 25.31 207.86 25.57 208.27 26.1C208.36 26.22 210.12 28.75 211.16 31.71C211.31 32.13 210.97 32.79 210.55 32.94C210.46 32.97 210.37 32.99 210.28 32.99V32.98Z'
				fill='#E49575'
			/>
			<path
				d='M208.89 34.48C208.49 34.48 208.15 34.19 208.09 33.78C207.8 31.7 207.5 31.65 207.03 30.9C206.79 30.52 206.19 29.82 206.48 29.49C206.76 29.15 207.36 29.51 207.7 29.8C207.77 29.86 209.24 30.7 209.69 33.13C209.77 33.57 209.43 34.42 208.99 34.48C208.95 34.48 208.91 34.48 208.88 34.48H208.89Z'
				fill='#E49575'
			/>
			<path
				d='M214.47 35.55C214.28 35.55 214.08 35.48 213.93 35.34C213.6 35.04 213.57 34.53 213.87 34.2C216.2 31.62 218.2 31.52 218.43 31.52H218.44C218.88 31.52 219.41 31.74 219.42 32.18C219.43 32.62 219.11 32.73 218.46 33.14C217.34 33.84 216.82 34.26 215.62 36.14C215.49 36.34 214.7 35.55 214.48 35.55H214.47Z'
				fill='#E49575'
			/>
			<path
				d='M215.61 36.13C215.2 36.74 214.42 37.53 214.16 37.76C213.9 37.99 213.66 39.4 211.9 39.63C210.77 39.78 209.15 39.72 209.46 37.41C209.77 35.1 211.61 33.93 213.87 34.2C216.13 34.47 215.61 36.14 215.61 36.14V36.13Z'
				fill='#E49575'
			/>
			<path
				d='M208.09 33.78C208.09 33.78 208.2 35.24 208.43 36.91C208.66 38.58 209.74 38.68 209.91 38.63L214.19 35.98L215.14 33.74L213.45 30.48C213.38 30.82 213 30.68 212.97 30.48C212.94 30.28 210.77 30.7 210.77 30.7L209.42 31.5L208.89 32.28L208.08 33.77L208.09 33.78Z'
				fill='#E49575'
			/>
			<path d='M293.321 34H274.641V61.61H293.321V34Z' fill='#303030' />
			<path d='M293.31 34V61.61H274.64V34H293.31ZM295.72 31.64H272.28V64.02H295.72V31.65V31.64Z' fill='#282828' />
			<path d='M317.621 52.98H301.831V76.31H317.621V52.98Z' fill='#303030' />
			<path d='M317.621 52.98V76.3H301.831V52.98H317.621ZM320.031 50.62H299.431V78.78H320.031V50.62Z' fill='#282828' />
			<path fillRule='evenodd' clipRule='evenodd' d='M306.98 73.28V62.32L312.47 67.79L306.98 73.28Z' fill='#383838' />
			<path fillRule='evenodd' clipRule='evenodd' d='M306.98 70.09V59.13L312.47 64.6L306.98 70.09Z' fill='#303030' />
			<path fillRule='evenodd' clipRule='evenodd' d='M306.98 66.74V55.78L312.47 61.25L306.98 66.74Z' fill='#383838' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M278.46 43.57H289.51V52.79L284.01 47.3V58.28L278.45 52.78V43.56L278.46 43.57Z'
				fill='#383838'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M278.46 40.47H289.51V49.69L284.01 44.2V55.18L278.45 49.68V40.46L278.46 40.47Z'
				fill='#303030'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M278.47 37.33H289.52V46.55L284.02 41.06V52.04L278.46 46.54V37.32L278.47 37.33Z'
				fill='#383838'
			/>
			<path
				d='M101.11 201.22C122.506 201.22 139.85 197.491 139.85 192.89C139.85 188.29 122.506 184.56 101.11 184.56C79.7146 184.56 62.3701 188.29 62.3701 192.89C62.3701 197.491 79.7146 201.22 101.11 201.22Z'
				fill='#181818'
			/>
			<path d='M74.8203 107.92H125.91C127.18 107.92 128.21 108.95 128.21 110.22V126.3H74.8203V107.92Z' fill='#303030' />
			<path
				d='M75.4903 95.66H100.83C101.2 95.66 101.51 95.96 101.51 96.34V107.92H74.8203V96.34C74.8203 95.97 75.1203 95.66 75.5003 95.66H75.4903Z'
				fill='#282828'
			/>
			<path d='M101.51 103.86L127.25 102.16C127.81 102.04 128.2 101.54 128.2 100.97V97.7401H101.51' fill='#282828' />
			<path
				d='M103.131 112.97H128.211V126.3H101.521V114.59C101.521 113.7 102.241 112.97 103.141 112.97H103.131Z'
				fill='url(#paint0_linear_2772_37440)'
			/>
			<path
				d='M128.21 126.3H74.81C72.54 126.3 70.72 128.18 70.79 130.45L71.35 148.36L71.69 159.38L72.03 170.41L72.65 190.4C72.69 191.55 73.63 192.46 74.77 192.46H128.24C129.39 192.46 130.33 191.55 130.36 190.4L130.98 170.41L131.32 159.38L131.66 148.36L132.22 130.45C132.29 128.18 130.47 126.3 128.2 126.3H128.21Z'
				fill='#282828'
			/>
			<path
				d='M79.7498 123.15H96.1698C96.6698 123.15 97.0498 122.69 96.9598 122.2L95.3298 113.61C95.2598 113.23 94.9298 112.96 94.5398 112.96H81.3798C80.9998 112.96 80.6598 113.23 80.5898 113.61L78.9598 122.2C78.8698 122.69 79.2398 123.15 79.7498 123.15Z'
				fill='#404040'
			/>
			<path
				d='M94.4004 148.35H108.62V150.83C108.62 151.65 107.96 152.31 107.14 152.31H95.8904C95.0704 152.31 94.4104 151.65 94.4104 150.83V148.35H94.4004Z'
				fill='#1E1E1E'
			/>
			<path
				d='M94.4004 170.28H108.62V172.76C108.62 173.58 107.96 174.24 107.14 174.24H95.8904C95.0704 174.24 94.4104 173.58 94.4104 172.76V170.28H94.4004Z'
				fill='#1E1E1E'
			/>
			<path
				d='M94.4004 126.3H108.62V128.78C108.62 129.6 107.96 130.26 107.14 130.26H95.8904C95.0704 130.26 94.4104 129.6 94.4104 128.78V126.3H94.4004Z'
				fill='#1E1E1E'
			/>
			<path
				d='M94.4004 181.3H108.62V183.78C108.62 184.6 107.96 185.26 107.14 185.26H95.8904C95.0704 185.26 94.4104 184.6 94.4104 183.78V181.3H94.4004Z'
				fill='#1E1E1E'
			/>
			<path
				d='M75.5905 195.77C76.2205 195.02 77.1505 194.52 78.2005 194.52C79.2505 194.52 80.1905 195.01 80.8105 195.77C81.2705 195.54 81.5806 195.07 81.5806 194.52V192.44H74.8105V194.52C74.8105 195.07 75.1306 195.53 75.5806 195.77H75.5905Z'
				fill='#1E1E1E'
			/>
			<path
				d='M122.2 195.77C122.83 195.02 123.76 194.52 124.81 194.52C125.86 194.52 126.8 195.01 127.42 195.77C127.88 195.54 128.19 195.07 128.19 194.52V192.44H121.42V194.52C121.42 195.07 121.74 195.53 122.19 195.77H122.2Z'
				fill='#1E1E1E'
			/>
			<g opacity='0.1'>
				<path
					d='M152.19 31.87L153.49 37.1L159.52 35.42L165.38 38.25L181.56 29.28L145.07 28.42L152.2 31.87H152.19ZM181.27 29.4L180.9 29.46L181.06 29.42L181.27 29.4Z'
					fill='black'
				/>
				<path
					d='M275.36 140.1C274.65 138.94 273.92 135.66 273.41 134.24C272.87 132.74 272.52 131.73 271.97 131.13C272 130.81 272.02 130.49 272.04 130.16C273.02 130.05 273.04 130.02 273.03 128.69C273.03 124.41 271.81 107.41 270.94 105.73C268.21 100.45 265.46 97.49 262.37 93.63C259.48 90.02 257.57 87.79 253.58 84.44C252.87 83.84 252.23 83.35 251.62 82.9C249.96 81.14 247 79.67 241.81 78.88C241.65 77.14 242.35 74.97 242.63 74.19C255.13 69.87 250.58 63.67 249.8 63.73C250.34 62.85 252.57 58.52 246.41 55.15C245.56 54.68 244.78 54.35 244.05 54.12C243.18 51.66 240.84 49.89 238.08 49.89C234.58 49.89 231.75 52.73 231.75 56.22C231.75 57.34 232.05 58.4 232.56 59.31C232.44 59.43 232.32 59.55 232.21 59.67C232.02 59.87 231.85 60.06 231.69 60.25C231.46 60.52 231.26 60.77 231.09 61C230.64 61.6 230.07 62.07 229.48 62.53C229.03 62.88 228.58 63.48 228.17 64.21C227.1 66.15 226.33 69 226.52 70.61C226.8 72.81 230.57 73.47 231.65 73.61C231.55 74.96 231.31 76.19 231.03 77.31C228.19 74.52 223.79 69.3 221.1 61.8C217.86 52.8 215.75 45.05 215.48 43.36C215.45 43.19 215.34 43.05 215.19 43C214.81 42.86 214.42 42.78 214.04 42.72C213.82 41.28 213.58 40.48 213.54 39.89C213.52 39.51 213.48 39.15 213.44 38.82C213.83 38.37 213.98 37.89 214.12 37.76C214.37 37.53 215.16 36.74 215.57 36.13C216.78 34.25 217.29 33.83 218.41 33.13C219.06 32.72 219.37 32.62 219.37 32.17C219.37 31.73 218.83 31.51 218.39 31.51H218.38C218.2 31.51 216.88 31.58 215.16 32.94C215.16 32.88 215.18 32.83 215.19 32.76C215.62 28.26 216.95 25.3 216.97 25.26C217.16 24.85 217.31 24.1 216.83 23.84C216.44 23.63 215.88 24.25 215.7 24.65C215.64 24.78 214.23 26.99 213.42 30.5C213.35 30.84 212.97 30.69 212.94 30.5C212.45 27.33 211.82 23.54 211.82 23.49C211.79 23.04 211.56 22.65 211.09 22.66C210.64 22.69 210.47 23.22 210.5 23.66C210.52 23.87 210.66 27.38 210.97 30.68C210.84 30.7 210.74 30.72 210.74 30.72C209.71 28.21 208.32 26.21 208.24 26.1C207.83 25.57 207.36 25.31 207.08 25.5C206.71 25.75 206.8 26.35 207.02 26.74C207.04 26.77 208.22 29.07 209.17 31.58C208.56 30.33 207.73 29.85 207.68 29.81C207.34 29.52 206.74 29.16 206.46 29.5C206.17 29.84 206.77 30.54 207.01 30.91C207.48 31.66 207.78 31.72 208.07 33.79C208.07 33.79 208.18 35.25 208.41 36.92C208.55 37.91 208.98 38.34 209.34 38.53C209.32 39.26 209.39 40.12 209.56 41.14C209.69 41.86 209.78 42.47 209.85 43.01C209.65 43.06 209.46 43.11 209.32 43.16C209.15 43.21 209.04 43.38 209.06 43.56C209.26 45.8 210.39 58.25 211.68 63.38C213.48 70.5 217.38 80.22 220.91 91.89C220.57 93.72 220.33 95.79 220.22 98.14C219.99 103 220.8 107.72 220.75 112.73C220.69 118.31 219.78 124.46 219.77 135.81C219.77 135.96 219.87 136.1 220.02 136.13C220.35 136.21 221.02 136.36 222.08 136.58C222.02 146.29 223.03 168.25 228.97 177.74C229.31 178.29 229.68 178.81 230.05 179.3C230.59 179.99 231.12 180.67 231.65 181.33C232.55 192.46 236.57 219.46 236.57 219.46C237 219.67 237.46 219.82 237.92 219.96C237.84 220.06 237.76 220.16 237.72 220.27C237.58 220.61 237.26 221.22 236.84 221.95C235.48 224.31 233.06 227.98 231.94 228.57C230.58 229.3 225.92 230.76 225.42 234.59C225.37 234.87 225.36 235.18 225.37 235.49C225.37 235.49 231.94 238.17 235.39 236.62C238.85 235.06 241.35 231.94 243.09 231.34C244.62 230.8 245.32 229.13 245.17 227.38C245.16 227.14 245.12 226.91 245.08 226.67C244.82 225.48 244.97 223.27 244.77 221.49C244.72 221.08 244.66 220.69 244.57 220.34C244.66 220.34 244.75 220.32 244.84 220.31C247.3 220.03 247.84 219.1 247.41 215.06C247.26 213.67 247.13 212.33 247.01 211.03C248.29 211.1 249.49 211.11 249.99 211.08C251.09 211.01 253.44 208.92 254.75 206.31C256.07 203.69 260.05 201.54 260.38 199.51C260.6 198.12 257.92 195.97 255.94 194.56C255.59 194.31 255.28 194.09 254.99 193.9C255.71 193.17 255.28 192.73 255 192.11C255 192.11 249.9 183.19 245.63 176.07C246.7 161.19 250.21 142.56 249.65 135.08C249.65 135.08 249.34 120.71 248.73 113.87C248.54 111.75 249.67 109.15 250.69 106.37C251.21 104.97 251.7 103.54 251.99 102.12C252.07 101.71 252.15 101.3 252.24 100.9C256.04 104.2 261.21 107.75 262.53 110.27C264.53 114.08 267.41 129.94 267.41 129.94C267.6 130.02 267.8 130.08 268.01 130.13C268.02 130.46 268.05 130.76 268.09 131.03C267.41 131.75 264.55 134.18 263.68 135.02C262.94 135.74 262.75 136.62 263.37 136.75C263.99 136.88 265.59 135.33 267.41 135.33C269.23 135.33 269.05 137.28 269.59 138.22C270.12 139.16 270.36 140.38 270.57 142.17C270.64 142.81 270.61 143.5 271.41 143.37C272.21 143.24 271.85 140.79 271.85 140.79C271.85 140.79 272.34 142.12 272.29 144.21C272.25 146.3 273.71 145.14 273.71 145.14C273.71 145.14 273.71 145.81 274.38 145.94C275.05 146.07 275.36 143.45 275.36 143.45C275.72 143.18 276.07 141.23 275.36 140.07V140.1ZM249.25 198.27C249.32 199.24 249.38 200.2 249.35 201.03C249.31 202.63 247.92 204.63 246.5 205.74C246.28 203.3 246.06 201.01 245.8 198.85C245.71 198.06 245.63 197.3 245.56 196.55C247.25 198.15 248.26 199.02 248.26 199.02L249.25 198.28V198.27Z'
					fill='black'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2772_37440'
					x1='114.771'
					y1='114.79'
					x2='114.941'
					y2='124.64'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='0.14' stopColor='#282828' />
					<stop offset='0.95' stopColor='#2F2F2F' />
					<stop offset='1' stopColor='#303030' />
				</linearGradient>
			</defs>
		</svg>
	),
)
